<template>

  <div class="main-container">

    <section v-if="loaded" class="container mt-0 pt-0">

          <div class="row m-0 pb-3 p-0 bg-white">
            
            <div class="col-12 col-md-6 offset-md-3 mt-4">

              <div class="row">

                <div class="col-4">
                  <b-img v-if="image" rounded="circle" :src="getImagePath(image, {width: 120,})" blank-color="#ccc" alt="placeholder" height="120" width="120" class="light-grey-border img-fluid"></b-img>
                  <b-img v-else rounded="circle" blank blank-color="#ccc" alt="placeholder" height="120" width="120" class="light-grey-border img-fluid"></b-img>
                </div>

                <div class="pl-0 col-8">
                  <p class="font-weight-light mb-1 mt-2">Show your appreciation for</p>
                  <h5 class="font-weight-normal dark-text">“{{username}}”</h5>
                </div>

              </div>

            <div class="form-group text-center">
              <label class="mt-3 font-weight-light" for="currency">Select Currency</label>
              <b-form-select v-model="chipin_form.currency" :state="validateState('currency')" :options="currencies"></b-form-select>
              <b-form-invalid-feedback class="mt-2">This is a required field.</b-form-invalid-feedback>
            </div>

            <p class="mb-2 font-weight-light text-center">Select the amount to Tip</p>

            <div class="w-100 text-center">

              <b-form-checkbox v-model="chipin_form.amount" value="500" name="check-button" class="mr-2" @change="chipin_form.other = false && show_error == false" button button-variant="outline-secondary">
                {{chosen_currency}}5
              </b-form-checkbox>

              <b-form-checkbox v-model="chipin_form.amount" value="1000" name="check-button" class="mx-2" @change="chipin_form.other = false && show_error == false" button button-variant="outline-secondary">
                {{chosen_currency}}10
              </b-form-checkbox>

              <b-form-checkbox v-model="chipin_form.amount" value="2000" name="check-button" class="mx-2" @change="chipin_form.other = false && show_error == false" button button-variant="outline-secondary">
                {{chosen_currency}}20
              </b-form-checkbox>

              <b-form-checkbox v-model="chipin_form.other" name="check-button" class="mx-2" button button-variant="outline-secondary">
                Other
              </b-form-checkbox>

              <div v-if="chipin_form.other" class="input-group mb-3 mt-3">
                <div class="input-group-prepend" v-if="chosen_currency">
                  <span class="input-group-text" id="basic-addon1">{{chosen_currency}}</span>
                </div>
                <input type="number" v-model="chipin_form.other_amount" class="form-control" placeholder="Enter amount" aria-describedby="basic-addon2">
              </div>

              <div class="mt-2 d-block invalid-feedback" v-if="form_submitted && (!chipin_form.other_amount || !chipin_form.amount)">This is a required field.</div>

              <b-form-checkbox class="mb-2 mt-3 mr-0 pr-0 font-weight-light" style="font-size: 12px;" id="checkbox-1" v-model="chipin_form.payment_type" value="subscription" unchecked-value="one_time">
                Support this Artist! Make this a monthly Tip<sup>*</sup>
              </b-form-checkbox>
              
            </div>

            <p class="text-center mt-2 pt-1 pb-0 mb-0 px-4 mx-3">
                <b-button class="mb-3 px-5 py-2 rounded-btn" size="md" block variant="info" @click="confirmPayment">
                  Send Tip
                </b-button>
                <a class="text-link dark-text font-weight-light" href="">Tell me more about ChipIn<sup>&reg;</sup></a>
            </p>

            <p class="text-center font-weight-light pt-3 mb-3">
              <img alt="Payment methods" class="img-fluid" src="../assets/payment-methods.png" />
            </p>

            <b-row>
              <b-col cols="6" class="text-center">
                <img alt="ChipIn" class="mt-2" height="25" src="../assets/chipin_logo.png" />
              </b-col>
              <b-col cols="6" class="text-center ">
                <img alt="Songs start here" height="45" src="../assets/song-start-here-logo.png" />
              </b-col>
              <b-col>
                <p class="text-left font-weight-light super-small mb-3 pb-3 mt-2">
                  Songs Start Here<sup>®</sup> is a charitable organisation supporting artists, musicians, and songwriters to fulfill their full potential. Donations are optional and do not provide app functionality. *ChipIn<sup>®</sup> renews each month until cancelled. Bank processing fees apply. Full terms <a target="_blank" class="dark-text text-underline d-inline" href="https://www.songsstarthere.org/privacy-policy-terms">here</a>.
                </p>
              </b-col>
            </b-row>

            </div>

        </div>

      </section>

  </div>
  
</template>

<script src="https://js.stripe.com/v3/"></script>

<script>
  import axios from "axios";
  import { validationMixin } from "vuelidate";
  import { required } from "vuelidate/lib/validators";

  export default {
    name: 'ChipIn',
    mixins: [validationMixin],
    data () {
        return {
          spk: process.env.VUE_APP_STRIPE_KEY,
          stripe:undefined,
          loaded: false,
          connected_account: null,
          username: null,
          image: null,
          form_submitted: false,
          data: {},
          chipin_form: {
            amount: null,
            other: false,
            other_amount: null,
            payment_type: 'subscription', //'one_time',
            currency: null
          },
          form_error: null,
          checkout_session_id: null,
          payment_loading: false,
          currencies: [
            {value: null, text: "Please select"},
            {value: "usd", text: "United States Dollar ($)"},
            {value: "gbp", text: "Pound Sterling (£)"},
            {value: "eur", text: "Euro (€)"},
          ]
        }
      },
    validations: {
      chipin_form: {
        currency: {
          required
        }
      }
    },
    methods: {
      validateState(name) {
        const { $dirty, $error } = this.$v.chipin_form[name];
        console.log(this.$v.chipin_form[name])
        return $dirty ? !$error : null;
      },
      confirmPayment() {

        var self = this;

        this.$v.chipin_form.$touch();

        if (!this.chipin_form.amount && !this.chipin_form.other_amount) {
           self.form_submitted = false;
           self.show_error = true
           return;
        } else if (this.chipin_form.other && this.chipin_form.other_amount < 1) {
          self.form_submitted = false;
          self.show_error = true
          return;
        }
        if (this.$v.chipin_form.$anyError) {
          self.form_submitted = false;
          return;
        }

      let token = null;
      let payment_to = null;

      try {
        token = this.$store.getters.getToken.access;
      } catch (err) {
        self.$router.replace({name: 'auth-error'})
      }

      try {
        payment_to = self.$store.state.payment_to.payment_to;
      } catch (err) {
        
        this.$router.replace({name: 'auth-error'})
      }
      
      //localStorage.getItem('accessToken')
      let headers = {
        'Authorization': 'JWT ' + token
      }

        axios.post('/chipin/api/checkout/', {
              "payment_type": self.chipin_form.payment_type,
              "currency": self.chipin_form.currency,
              "amount": self.chipin_amount_payment,
              "payment_to": parseInt(payment_to)
        }, {'headers': headers}
        )
        .then(res => {
          //console.log(res.data)

          self.checkout_session_id = res.data.checkout_session_id;
          self.connected_account = res.data.connected_account;

          return self.stripe.redirectToCheckout({ 
            sessionId: res.data.checkout_session_id,
            })
          
        })
        .catch(error => {
          self.payment_loading = false
          return
        });

      },           
    },
    computed: {
      chipin_amount_payment () {

        if (this.chipin_form.other) {
            return (Number(this.chipin_form.other_amount) * 100)
        } else {
          return this.chipin_form.amount
        }
      
      },
      chosen_currency () {
        
        if (this.chipin_form.currency) {

          if (this.chipin_form.currency == 'gbp') {
            return '£'
          }
          if (this.chipin_form.currency == 'eur') {
            return '€'
          }
          if (this.chipin_form.currency == 'usd') {
            return '$'
          }

        } else {

          return null

        }

      }
      
    },
    beforeMount() {

    },
    mounted: function () {

      var self = this;

      // GET Connected account

      var account_id = null;

      axios.post('/chipin/api/checkout/account/', {
            "id": parseInt(self.$store.state.payment_to.payment_to)
        })
        .then(res => {

          account_id = res.data.id;
          this.username = res.data.username
          this.image = res.data.image
          this.$store.dispatch('storePhoto', res.data.image)

          var spk = null
          if (res.data.stripe_account_type === 'ssh') {
            spk = process.env.VUE_APP_STRIPE_KEY
          } else {
            spk = process.env.VUE_APP_STRIPE_TCLLC_KEY
          }

          self.stripe = Stripe(spk, {stripeAccount: res.data.id});

          this.loaded = true

        })
        .catch(error => {
          console.log(error)
          return
        });
      
    },
  }
  
</script>


<style scoped>

  .light-grey-border {
    border: 2px solid #9B9B9B
  }

  .red-text {
    color: #FF0000;
  }
  
  .dark-text {
    color: #595959;
  }

  .super-small {
    font-size: 10px;
    color: #595959;
  }

  .rounded-btn {
    border-radius: 10px;
  }

  select {
    border-color: #9B9B9B !important;
  }

  .text-underline {
    text-decoration: underline !important;
  }

</style>
